import React, { useContext } from 'react'
import styles from "./item.module.css";
import star_icon from "../../../assets/star_rating.png"
import remove_icon from "../../../assets/remove_icon.png";
import {AuthContext} from "../../../contextAPI"
import { RemoveReviewById } from '../../../utils/reviews';
import { notify } from '../../toast';


const FeedbackListItem = (props) => {

  const Auth = useContext(AuthContext);
  const token = Auth.isLoggedIn ? Auth.authenticatedUser.token.access_token : null

  const onRemoveReviewHandler = async() => {

    try {
      const response = await RemoveReviewById({
        review_id: props.item._id,
      }, token)

      if(!response.status || !response.data) throw new Error(response.message);
      notify(response.message, "success")

    } catch (error) {

      return notify(error.message, "error")
    }

    return props.onRefresh()
  }

  return (
    <div key={props.item.review} className={`${styles.slide_container} ${!props.isActive && styles.hidden_slide}`}>
      {
        <div className={styles.wrapper}>
          <div className={styles.rating}>
            {
              [1,2,3,4,5].map(index => {
                
                return <img key={index} alt='' src={star_icon} />
              })
            }
          </div>
          <div className={styles.review}>
            <p className={styles.review_text}>{props.item.comment}</p>
          </div>
          
          { Auth.isLoggedIn &&
            <div onClick={onRemoveReviewHandler} className={styles.controller}>
              <img alt='' src={remove_icon} />
            </div>
          }
        </div >
      }
    </div>
  )
}

export default FeedbackListItem